import { createSlice } from '@reduxjs/toolkit';
//
import { dispatch, store } from '../store';
// utils
import { callApi } from '../../utils/apiCall';
import { errorHandler } from '../../utils/errorHandler';
import { clearCached } from '../../utils/staticLookupCache';
import { getPracticeContextCacheKey } from './mergeTags';

// ---------------------------------------------------------------------
const initialState = {
    isLoading: false,
    practice: {},
    activeTab: 'General'
};


const slice = createSlice({
    name: 'singlePractice',
    initialState,
    reducers: {
        reset(state) {
            Object.assign(state, initialState);
        },
        getSinglePracticeData(state, action) {
            state.isLoading = false;
            state.practice = action.payload;
        },
        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        updateLoader(state, action) {
            state.isLoading = action.payload;
            state.practice = {};
        },
        updatePracticeDetail(state, action) {
            state.isLoading = false;
            state.practice = action.payload;
        },
        updatePracticeDetailTab(state, action) {
            state.activeTab = action.payload;
        }
    }
});

// Reducer
export default slice.reducer;
export const { updatePracticeDetail, updatePracticeDetailTab, reset } = slice.actions;


export function getPracticeItem(id) {
    return async () => {
        const requestedId = String(id);
        try {
            dispatch(slice.actions.updateLoader(true));
            const response = await callApi(`/api/v1/practices/${id}/`);
            if (response.status === 200) {
                const currentPracticeId = store.getState().practiceTreatmentList?.practiceId;
                if (String(currentPracticeId) !== requestedId || String(response.data?.id) !== requestedId) {
                    return;
                }
                dispatch(slice.actions.getSinglePracticeData(response.data));
            } else {
                errorHandler(response.data,'',slice.actions.hasError);
            }
        } catch (error) {
            errorHandler(error,'',slice.actions.hasError);
        }
    };
}

/**
 * PATCH a subset of fields on the current practice. Admin-only on the
 * backend for `google_review_threshold` (serializer-level gate). Other
 * fields follow their own permission rules.
 *
 * On success, updates Redux state with the server-returned practice payload
 * (so any computed fields the backend touches stay consistent) and
 * optionally invokes `onSuccess({ data })` / `onError({ error })`.
 */
export function patchPractice(id, patch, { onSuccess, onError } = {}) {
    return async () => {
        const requestedId = String(id);
        try {
            const response = await callApi(`/api/v1/practices/${id}/`, 'patch', patch);
            if (response.status === 200) {
                const currentPracticeId = store.getState().practiceTreatmentList?.practiceId;
                if (String(currentPracticeId) !== requestedId || String(response.data?.id) !== requestedId) {
                    return;
                }
                dispatch(slice.actions.updatePracticeDetail(response.data));
                // See updatePractice (src/redux/slices/practice.js) — same
                // get_context TTL-cache invalidation for this practice-detail PATCH.
                clearCached(getPracticeContextCacheKey(id));
                if (onSuccess) onSuccess({ data: response.data });
                return;
            }
            const errMsg = response.data?.detail
                || Object.values(response.data || {})[0]
                || 'Could not update practice.';
            if (onError) onError({ error: errMsg });
            errorHandler(response.data, '', slice.actions.hasError);
        } catch (error) {
            if (onError) onError({ error: error.message || 'Could not update practice.' });
            errorHandler(error, '', slice.actions.hasError);
        }
    };
}